import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import apiClient from '../api/client';
import './DashboardJogador.css';

/**
 * Dashboard do Jogador - Versão 2
 * Exibe ranking, nocautes, financeiro e saldo BAR
 */

const DashboardJogador = () => {
  const { user } = useAuth();
  const [rankingPontos, setRankingPontos] = useState([]);
  const [rankingNocautes, setRankingNocautes] = useState([]);
  const [minhaPosicaoPontos, setMinhaPosicaoPontos] = useState(null);
  const [minhaPosicaoNocautes, setMinhaPosicaoNocautes] = useState(null);
  const [rodadasAbertas, setRodadasAbertas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    carregarDados();
  }, [user]);

  const carregarDados = async () => {
    try {
      setLoading(true);
      setError('');

      const [rankingRes, nocautesRes, rodadasRes] = await Promise.all([
        apiClient.get('/ranking'),
        apiClient.get('/nocautes/ranking-dados'),
        apiClient.get('/rodadas'),
      ]);

      const ranking = Array.isArray(rankingRes.data) ? rankingRes.data : [];
      const nocautes = Array.isArray(nocautesRes.data) ? nocautesRes.data : [];
      const rodadas = Array.isArray(rodadasRes.data) ? rodadasRes.data : [];

      setRankingPontos(ranking);
      setRankingNocautes(nocautes);

      // Encontrar minha posição
      const minhaPosicaoP = ranking.findIndex(r => r.jogador.id === user.id);
      if (minhaPosicaoP !== -1) {
        setMinhaPosicaoPontos({
          posicao: minhaPosicaoP + 1,
          ...ranking[minhaPosicaoP],
        });
      }

      const minhaPosicaoN = nocautes.findIndex(r => r.jogador.id === user.id);
      if (minhaPosicaoN !== -1) {
        setMinhaPosicaoNocautes({
          posicao: minhaPosicaoN + 1,
          ...nocautes[minhaPosicaoN],
        });
      }

      // Filtrar rodadas abertas
      const abertas = rodadas.filter(r => r.status === 'aberta');
      setRodadasAbertas(abertas);

    } catch (err) {
      console.error('Erro ao carregar dados:', err);
      setError(err.response?.data?.error || 'Erro ao carregar dados');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="container">Carregando...</div>;
  }

  return (
    <div className="dashboard-jogador-container">
      <div className="dashboard-jogador-header">
        <h1>Bem-vindo, {user?.nome}!</h1>
        <p>Seu dashboard pessoal</p>
      </div>

      {error && <div className="error">{error}</div>}

      {/* Rodadas Abertas */}
      {rodadasAbertas.length > 0 && (
        <div className="dashboard-section">
          <h2>🎲 Rodadas Abertas</h2>
          <div className="rodadas-list">
            {rodadasAbertas.map(rodada => (
              <Link
                key={rodada.id}
                to={`/rodadas/${rodada.id}/confirmar`}
                className="rodada-card"
              >
                <div className="rodada-data">
                  {new Date(rodada.data).toLocaleDateString('pt-BR')}
                </div>
                <div className="rodada-action">
                  Confirmar Presença →
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}

      {/* Ranking de Pontos */}
      <div className="dashboard-section">
        <h2>🏆 Ranking de Pontos</h2>
        {minhaPosicaoPontos ? (
          <div className="minha-posicao-card">
            <div className="posicao-badge">{minhaPosicaoPontos.posicao}º</div>
            <div className="posicao-info">
              <div className="posicao-titulo">Sua Posição</div>
              <div className="posicao-valor">{minhaPosicaoPontos.total_pontos} pontos</div>
              <div className="posicao-detalhes">{minhaPosicaoPontos.total_rodadas} rodadas</div>
            </div>
          </div>
        ) : (
          <div className="sem-posicao">Você ainda não tem pontos no ranking</div>
        )}
        <Link to="/ranking" className="btn-link">
          Ver Ranking Completo →
        </Link>
      </div>

      {/* Ranking de Nocautes */}
      <div className="dashboard-section">
        <h2>🥊 Ranking de Nocautes</h2>
        {minhaPosicaoNocautes ? (
          <div className="minha-posicao-card">
            <div className="posicao-badge">{minhaPosicaoNocautes.posicao}º</div>
            <div className="posicao-info">
              <div className="posicao-titulo">Sua Posição</div>
              <div className="posicao-valor">{minhaPosicaoNocautes.total_nocautes} nocautes</div>
            </div>
          </div>
        ) : (
          <div className="sem-posicao">Você ainda não tem nocautes</div>
        )}
        <Link to="/nocautes" className="btn-link">
          Ver Ranking Completo →
        </Link>
      </div>

      {/* Financeiro */}
      <div className="dashboard-section">
        <h2>💰 Financeiro</h2>
        <Link to="/financeiro" className="btn-link">
          Consultar Saldo por Rodada →
        </Link>
      </div>

      {/* Saldo BAR */}
      <div className="dashboard-section">
        <h2>🍺 Saldo BAR</h2>
        <Link to="/saldo-bar" className="btn-link">
          Consultar Meu Saldo BAR →
        </Link>
      </div>

      {/* Imagens de Nocaute */}
      <div className="dashboard-section">
        <h2>🎨 Minhas Imagens de Nocaute</h2>
        <p style={{ marginBottom: '10px', color: '#666' }}>
          Faça upload de imagens personalizadas para seus nocautes e eliminações!
        </p>
        <Link to="/minhas-imagens-nocautes" className="btn-link">
          Gerenciar Minhas Imagens →
        </Link>
      </div>
      
      <footer className="app-footer">
        <div className="footer-content">
          <p className="footer-signature">
            Produzido by <strong>Chicão</strong>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default DashboardJogador;
